import { addUserConfig, getUserConfigValue, queryUserConfig, updateUserConfigValue } from '@/services/user'

export enum ConfigKeyType {
    PAY_NOTICE = 'PAY_NOTICE',
    AFTER_AUTO_TIP = 'AFTER_AUTO_TIP',
    UPDATE_NOTICE = 'UPDATE_NOTICE'
}
export enum RequestType {
    drp = 'drp',
    security = 'security'
}

interface PropsType {
    configKey: ConfigKeyType
    /**
     * @default security
     * @description 默认请求列设置那个接口
     */
    requestType?: 'drp' | 'security'
}

const requestMap = {
    drp: {
        get: ({ configKey }: any) => {
            return getUserConfigValue({
                configType: configKey
            })
        },
        set: ({ configKey, configValue }: any) =>
            updateUserConfigValue({
                configType: configKey,
                configValue
            })
    },
    security: {
        get: queryUserConfig,
        set: ({ configKey, configValue }: any) =>
            addUserConfig({
                configKey,
                configValue: { data: configValue }
            })
    }
}

/**
 *  后端接口层面的我知道了
 * uid 维度
 * @param props
 * @returns
 */
const ServiceIknow = ({ configKey, requestType }: PropsType) => {
    const { get, set } = requestMap[requestType || 'security']
    const getServiceIknow = async () => {
        const res = await get({
            configKey
        })
        if (res.success) {
            const data = requestType === RequestType.drp ? res.data : res.data?.[configKey]?.data
            return data
        }
    }

    const setServiceIknow = async (configValue: boolean) => {
        const res = await set({
            configKey,
            configValue
        })
        if (res.success) {
            const data = requestType === RequestType.drp ? res.data : configValue
            return data
        }
    }

    return {
        getServiceIknow,
        setServiceIknow
    }
}

export default ServiceIknow
